<template>
  <div class="table">
    <b-table
      :items="items"
      :fields="fields"
      :busy="loading"
      hover
      show-empty
      responsive
      :select-mode="selectMode"
      @row-selected="$emit('onRowSelected', $event)"
      @row-clicked="$emit('onRowClicked', $event)"
      ref="selectableTable"
      :selectable="selectable"
      class="c-table"
    >
      <template #row-details="row">
        <slot name="row-details" :data="row" />
      </template>
      <template #cell()="data">
        <slot :name="data.field.key" :data="data" />
      </template>
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>loading...</strong>
        </div>
      </template>
      <template #empty>
        <div class="w-100 d-flex justify-content-center p-5">
          <h4 class="text-muted">no information</h4>
        </div>
      </template>
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span class="text-success h3" aria-hidden="true">&check;</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;&nbsp;</span>
        </template>
      </template>
    </b-table>
  </div>
</template>

<script>
import {
  BTable,
  BFormCheckbox,
  BButton,
  BSpinner,
  BCard,
  BRow,
  BCol,
  BAvatar,
  BBadge,
} from "bootstrap-vue";

export default {
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BSpinner,
    BCard,
    BRow,
    BCol,
    BBadge,
    BAvatar,
  },
  props: {
    selectMode: {
      type: String,
      default: "multi",
    },
    selectable: {
      type: Boolean,
      default: false,
    },

    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style  lang="scss">

</style>
